module.exports = __webpack_public_path__ + "static/media/loader.1b014ef9.svg";